import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

interface SelectedProfile {
  fullName: string
  username?: string
  avatarUrl?: string
  bio?: string
  profileUrl?: string
}

interface ValidateSocialImportData {
  importId: string
  selectedProfiles: SelectedProfile[]
}

interface ValidateSocialImportResponse {
  createdIds: string[]
}

const validateSocialImport = async (data: ValidateSocialImportData): Promise<ValidateSocialImportResponse> => {
  const { data: response } = await api.post<ValidateSocialImportResponse>(
    `/ft_import-contacts/${data.importId}/validate`,
    { selectedProfiles: data.selectedProfiles },
  )
  return response
}

export const useFtValidateSocialImport = () => {
  const queryClient = useQueryClient()

  return useMutation<ValidateSocialImportResponse, Error, ValidateSocialImportData>({
    mutationFn: validateSocialImport,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['contacts'] })
    },
  })
}
